import React, { useState, useRef, useEffect } from 'react';

const Tooltip = ({ children, content, isOnClick = false, wrapperClassName = '', placement = 'top' }) => {
	const [open, setOpen] = useState(false);
	const rootRef = useRef(null);

	useEffect(() => {
		if (!isOnClick) return;
		const handleClickOutside = (e) => {
			if (rootRef.current && !rootRef.current.contains(e.target)) {
				setOpen(false);
			}
		};
		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, [isOnClick]);

	const toggle = () => {
		if (isOnClick) setOpen((prev) => !prev);
	};

	const tooltipStyle = {
		backdropFilter: 'blur(20px)',
	};

	// Resolve placement-specific classes
	const isBottom = placement === 'bottom';
	const isLeft = placement === 'left';
	const isRight = placement === 'right';

	let containerPositionClasses = '';
	let arrowPositionClasses = '';

	if (isBottom) {
		containerPositionClasses = 'top-full left-1/2 mt-3 -translate-x-1/2';
		arrowPositionClasses = '-top-1.5 left-1/2 -translate-x-1/2';
	} else if (isLeft) {
		containerPositionClasses = 'right-full top-1/2 -translate-y-1/2 mr-3';
		arrowPositionClasses = 'left-full top-1/2 -translate-y-1/2 -ml-1.5';
	} else if (isRight) {
		containerPositionClasses = 'left-full top-1/2 -translate-y-1/2 ml-3';
		arrowPositionClasses = 'right-full top-1/2 -translate-y-1/2 -mr-1.5';
	}
	else {
		// default top
		containerPositionClasses = 'bottom-full left-1/2 mb-3 -translate-x-1/2';
		arrowPositionClasses = '-bottom-1.5 left-1/2 -translate-x-1/2';
	}

	return (
		<div
			ref={rootRef}
			className={`relative block ${!isOnClick ? 'group' : ''} ${wrapperClassName}`}
			onClick={isOnClick ? toggle : undefined}
		>
			{/* Trigger button */}
			<span className="inline-flex w-full">{children}</span>

			{/* Tooltip content */}
			<div
				role="tooltip"
				style={tooltipStyle}
				className={`absolute w-[200px] ${containerPositionClasses} z-[9999] rounded-md bg-[#87868B] text-white text-center py-2 px-4 text-xs font-medium transition-opacity duration-300
					${isOnClick
						? open
							? 'opacity-100 visible'
							: 'opacity-0 invisible'
						: 'opacity-0 invisible group-hover:opacity-100 group-hover:visible'
					}
				`}
			>
				{/* Tooltip pointer/arrow */}
				<span
					className={`absolute backdrop-blur-md ${arrowPositionClasses} -z-10 h-3 w-3 rotate-45 bg-[#87868B]`}
				></span>
				{content}
			</div>
		</div>
	);
};

export default Tooltip;
